import Swiper from 'swiper';
import { Grid, Pagination } from 'swiper/modules';

let gameSwipers = new Map(); // Store multiple swiper instances

function initOrDestroySwiper() {
  const containers = document.querySelectorAll('.game-slider .swiper');
  const isMobile = window.innerWidth <= 767;

  containers.forEach(container => {
    const containerId = container.id || container.closest('.game-slider').id || `game-slider-${Array.from(containers).indexOf(container)}`;
    
    // Get limits from the first game card data attributes in this container
    const firstGameCard = container.querySelector('.game-card[data-limit-desktop]');
    const limitDesktop = firstGameCard ? parseInt(firstGameCard.dataset.limitDesktop, 10) : 7;
    const limitMobile = firstGameCard ? parseInt(firstGameCard.dataset.limitMobile, 10) : 50;

    if (isMobile && !gameSwipers.has(containerId)) {
      if (!container.querySelector('.swiper-pagination')) {
        const pag = document.createElement('div');
        pag.className = 'swiper-pagination';
        container.appendChild(pag);
      }

      const swiper = new Swiper(container, {
        modules: [Grid, Pagination],
        slidesPerView: 3,
        slidesPerGroup: 3, // Move 3 slides at a time (one row)
        grid: {
          rows: 2,
          fill: 'row',
        },
        spaceBetween: 8,
        centeredSlides: false,
        normalizeSlideIndex: true,
        roundLengths: true,
        watchSlidesProgress: true,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
          // Adjust for different screen sizes if needed
          480: {
            spaceBetween: 10,
          }
        },
        on: {
          slideChange: function() {
            // Force recalculation of slide positions
            this.updateSlides();
            this.updateProgress();
          }
        }
      });

      gameSwipers.set(containerId, swiper);
    }
    else if (!isMobile && gameSwipers.has(containerId)) {
      const swiper = gameSwipers.get(containerId);
      swiper.destroy(true, true);
      gameSwipers.delete(containerId);
      const pag = container.querySelector('.swiper-pagination');
      if (pag) pag.remove();
    }

    // Nothing to reveal or re-hide here any more. Games past the desktop limit ship visible
    // in the markup and are hidden on desktop by CSS alone
    // (`.game-slider .swiper-slide.mobile-only-game` in the _base.scss up(md) branch).
    //
    // This used to clear the inline display:none that games-list.twig emitted — AFTER the
    // constructor above had already run. Swiper therefore sized its track from the desktop
    // set only, and when its own ResizeObserver noticed the element had grown it re-ran a
    // full update seconds later; that correction was the lobby's 0.7645 CLS. Isolated
    // fixture: 1.1237 with the inline style and this reveal, 0.011 without either.
    //
    // Dropping it also fixes a latent bug: the mobile branch removed the `mobile-only-game`
    // class, so a later resize to desktop could no longer find those cards to hide.
  });
}

// on resize (debounced)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initOrDestroySwiper, 200);
});

// Run immediately if DOM is already loaded to prevent flicker.
// NB: there used to be a second, unconditional `DOMContentLoaded` listener above this block,
// so initOrDestroySwiper ran twice on DCL. The duplicate was harmless (the second pass is a
// no-op thanks to the `!gameSwipers.has(containerId)` guard) but it is gone now — this branch
// already covers both the "still parsing" and "already parsed" cases.
if (document.readyState === 'loading') {
  // DOM hasn't finished loading yet
  window.addEventListener('DOMContentLoaded', initOrDestroySwiper);
} else {
  // DOM has already loaded
  initOrDestroySwiper();
}
